<template>
  <div>
    <z-title
      tag="h3"
      size="medium"
      weight="middle"
      class="related-lessons__title"
    >
      Estude também
    </z-title>

    <div class="related-lessons__content">
      <div
        v-for="relatedLesson in relatedLessons"
        :key="relatedLesson.slug"
        class="related-lessons_lesson"
      >
        <VLazyImage
          :src="imageSource(relatedLesson.cover_image)"
          :alt="relatedLesson.title"
          class="related-lesson__lesson-cover"
        />

        <z-link
          :href="`/enem/${categorySlug}/${relatedLesson.slug}`"
        >
          {{ relatedLesson.title }}
        </z-link>
      </div>
    </div>
  </div>
</template>

<script>
import VLazyImage from 'v-lazy-image/v2'

export default {
  name: 'RelatedLessons',
  components: {
    VLazyImage,
  },
  props: {
    categorySlug: {
      type: String,
      required: true,
    },
    relatedLessons: {
      type: Array,
      required: true,
    },
  },
  methods: {
    imageSource (coverImage) {
      return this.$mediaHub(coverImage)
    },
  },
}
</script>

<style lang="scss" scoped>
.related-lessons__content {
  display: grid;
  gap: var(--unit-0600);

  @media (min-width: $breakpoint-tablet) {
    grid-template-columns: repeat(2, 1fr)
  }
}

.related-lessons__title {
  margin: var(--unit-0800) 0 var(--unit-0300)
}

.related-lessons_lesson {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: var(--unit-0400);
}

.related-lesson__lesson-cover {
  border-radius: var(--border-radius-small);
  box-shadow: var(--elevation-down-10);
  height: var(--unit-1600);
  object-fit: cover;
  width: var(--unit-1600);
}
</style>
